exports.stripTag = (string) => {
  return string.replace(/<\/?[^>]+>/ig, " ");
}
